import { HttpErrorResponse } from '@angular/common/http';
import { Injectable, signal } from '@angular/core';
import { first, Subject } from 'rxjs';

import { UsersApiService } from '../../api-services/users-api/users-api.service';
import { PortfoliosManager, UpdatePortfolio, User } from '../../models';
import { AuthService } from '../auth/auth.service';
import { LoadingService } from '../loading/loading.service';

@Injectable()
export class PortfolioService {
  portfolios = signal<string[]>([]);
  dismissModal$ = new Subject<void>();
  constructor(
    private userService: UsersApiService,
    private loadingService: LoadingService,
    private authService: AuthService
  ) {}

  /* SIGNALS */
  setPortfolios(portfolios: string[]): void {
    this.portfolios.set(portfolios);
  }
  /* END SIGNALS */

  async getPortfolios(user: User): Promise<void> {
    this.userService
      .getManagedPortfolios(user.id)
      .pipe(first())
      .subscribe({
        next: (resp: PortfoliosManager) => this.onSuccessGetPortfolios(resp),
        error: (error: HttpErrorResponse) => this.onErrorGetPortfolios(error)
      });
  }

  async updatePortfolio(
    user: User,
    portfolioId: string,
    fromModal: boolean = false
  ): Promise<void> {
    const data: UpdatePortfolio = {
      portfolioId
    };
    await this.loadingService.presentSecondLoader(null, false);
    this.userService
      .updateManagerPortfolio(user.id, data)
      .pipe(first())
      .subscribe({
        next: () => this.onSuccessSavePortfolio(user, portfolioId, fromModal),
        error: (error: HttpErrorResponse) => this.onErrorSavePortfolio(error)
      });
  }

  private async onSuccessGetPortfolios(resp: PortfoliosManager): Promise<void> {
    this.setPortfolios(resp.portfolios);
  }

  private async onErrorGetPortfolios(error: HttpErrorResponse): Promise<void> {
    console.error('error get portfolios', error);
  }

  private async onSuccessSavePortfolio(
    user: User,
    portfolioId: string,
    fromModal: boolean
  ): Promise<void> {
    await this.loadingService.dismissSecondLoader();
    user.portfolioId = portfolioId;
    this.authService.setUser(user);
    if (fromModal) {
      this.dismissModal$.next();
    } else {
      location.reload();
    }
  }

  private async onErrorSavePortfolio(error: HttpErrorResponse): Promise<void> {
    console.error('error save portfolio', error);
    await this.loadingService.dismissSecondLoader();
  }
}
